const reducer = (state, { result = {} }) => {
  return {
    ...state,
    serverError: result.error,
  };
};

export default reducer;
